export default function addresses(state = [], action) {
  const initialState = []
  switch (action.type) {
    case 'RECEIVE_ADDRESS': {
      return state
        .map(address => {
          return { ...address, primary: false }
        })
        .concat(action.payload)
    }

    case 'RECEIVE_ADDRESSES': {
      return action.payload || state
    }

    case 'REMOVE_ADDRESS': {
      return state.filter(address => address.id !== action.payload)
    }

    case 'REMOVE_SESSION_ADDRESSES': {
      return initialState
    }

    default:
      return state
  }
}

export function getPrimaryAddress(addresses) {
  return addresses.find(address => address.primary)
}
